export const reviewsData = [
  {
    id: 1,
    name: "Priya Sharma",
    course: "Flutter + Firebase",
    rating: 5,
    review: "SkillYatra's Flutter course completely transformed my career. The instructors were knowledgeable and supportive, and I was able to build my first app within weeks! I now work as a mobile app developer.",
    date: "2025-03-15"
  },
  {
    id: 2,
    name: "Rahul Verma",
    course: "MERN Stack (Full Stack)",
    rating: 4.5,
    review: "The MERN Stack course is comprehensive and well-structured. I learned everything from basic MongoDB to advanced React concepts. The course projects were challenging but immensely helpful for my portfolio.",
    date: "2025-04-02"
  },
  {
    id: 3,
    name: "Anjali Patel",
    course: "3ds Max + V-ray",
    rating: 5,
    review: "I had no prior experience with 3D modeling, but SkillYatra made it easy to understand. The V-ray rendering techniques I learned helped me land a job at a top design studio. Highly recommended!",
    date: "2025-02-18"
  },
  {
    id: 4,
    name: "Arjun Singh",
    course: "Flutter + Firebase",
    rating: 4.8,
    review: "The course content is up-to-date with the latest Flutter features and Firebase integration techniques. The hands-on projects helped me understand real-world application development.",
    date: "2025-05-10"
  }
];
